module.exports = __webpack_public_path__ + "static/media/arachide.4b6bc101.png";